import { IApplicationState } from '../../types/redux';

export function subdomainReducer(state: IApplicationState['subdomain'] = 'www'): IApplicationState['subdomain'] {
  return state;
}
